"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var pirkka_svg_1 = __importDefault(require("../../../../images/brands/pirkka.svg"));
var __1 = require("..");
var BrandImage = function (_a) {
    var styles = _a.styles, brand = _a.brand;
    if (brand === 'pirkka') {
        return (react_1.default.createElement("img", { style: {
                maxHeight: '60px',
                maxWidth: '200px',
                padding: '10px 0px 0px 100px'
            }, src: pirkka_svg_1.default, alt: 'pirkka' }));
    }
    return (react_1.default.createElement(react_1.Fragment, null, brand && (react_1.default.createElement(__1.Text, { id: 'brand', styles: styles, value: brand, textfit: { max: 60, mode: 'multi' } }))));
};
exports.default = BrandImage;
//# sourceMappingURL=BrandImage.js.map